import styled from 'styled-components';
import { REFERRAL_ORDER_BANNER } from '../../../../public/images';
 
 const ReferralInfoBannerStyled = styled.div`
  .referral-banner {
    border-radius: ${(props) => props?.theme?.spacing?.cornerRadius?.sm};
    border: 1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
    margin-top: ${(props) => props?.theme?.spacing?.margin?.lg};
    width: 100%;
    min-height: 151px;
    background-size: cover;
    background-image: ${(props) => (!props.hasCouponCode ? `url(${REFERRAL_ORDER_BANNER.src})` : 'none')};
    background: ${(props) => (props.hasCouponCode ? `linear-gradient(90deg, ${props?.theme?.color?.blueIceberg} 0%, ${props?.theme?.color?.oldLace} 112.04%)` : '')};
    padding: ${(props) => props?.theme?.spacing?.padding?.lg};
    padding-bottom: ${(props) => props?.theme?.spacing?.padding?.md};
    display: flex;

    .title {
      font-size: 23.59px;
      font-weight: 700;
      line-height: 20.65px;
      text-align: left;
     }

    .title-code {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      text-align: left;
    }

    .description {
      font-size: 13.27px;
      font-weight: 600;
      line-height: 17.7px;
      text-align: left;
      color: ${(props) => props?.theme?.text?.medium};
      margin-top: 12px;
    }

    .description-code {
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      text-align: left;
      color: ${(props) => props?.theme?.text?.medium};
      margin-top: 13px;
    }

    .refer-button {
      margin-top: 18px;
    }

    .referral-coupon-code-container {
      display: flex;
      align-items: center;
    }

    .coupon-box {
      margin-left: 8px;
      height: 32px;
      padding: 4px 12px 4px 12px;
      gap: 4px;
      border-radius: 4px;
      background-color: white;
      border: 1px solid ${(props) => props?.theme?.colors?.primary?.green?.['700']};
      color: ${(props) => props?.theme?.colors?.primary?.green?.['700']};
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      display: flex;
      cursor: pointer;

      img {
        margin-top: 4px;
      }
    }
  }
`;

export default ReferralInfoBannerStyled;
